/* unplugin-vue-components disabled */import { render } from "./BusPassengerView.vue?vue&type=template&id=273efd22&scoped=true"
import script from "./BusPassengerView.vue?vue&type=script&lang=js"
export * from "./BusPassengerView.vue?vue&type=script&lang=js"

import "./BusPassengerView.vue?vue&type=style&index=0&id=273efd22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273efd22"]])

export default __exports__